import React from 'react';

import Avatar from '@atlaskit/avatar/avatar';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Text } from '@atlaskit/primitives/compiled/text';

type BulkConfigureSelectOptionProps = {
	label: string;
	avatarUrl: string;
};

export const BulkConfigureSelectOption = ({
	label,
	avatarUrl,
}: BulkConfigureSelectOptionProps): React.JSX.Element => {
	return (
		<Inline space="space.100" alignBlock="center">
			<Avatar appearance="square" size="xsmall" src={avatarUrl} />
			<Text size="medium">{label}</Text>
		</Inline>
	);
};
